var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-full flex-col"},[_c('demo-header'),_c('calendly-widget'),_c('partner-feedback')],1)}
var staticRenderFns = []

export { render, staticRenderFns }